var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 19.984c7.506 0 13.626 6.02 13.748 13.526a1.25 1.25 0 0 1-.729 1.156A31.137 31.137 0 0 1 20 37.5a31.13 31.13 0 0 1-13.02-2.834 1.25 1.25 0 0 1-.728-1.156C6.374 26.004 12.494 19.984 20 19.984zm0 2.5c-5.813 0-10.609 4.412-11.19 10.09l-.015.159.482.2a28.63 28.63 0 0 0 10.027 2.059l.698.008a28.64 28.64 0 0 0 10.711-2.063l.491-.204-.013-.158c-.571-5.572-5.199-9.924-10.863-10.086L20 22.484zM20 2.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15zM20 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10z",
    fill: "#8E06BF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPurple);
export default __webpack_public_path__ + "static/media/user-purple.bcd64252a0a8c06696e9ac5f2d9f3271.svg";
export { ForwardRef as ReactComponent };